<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="radioButtonValue"
	[label]="step2.getspan4"
	[type]="'radio'"
	[rule]="'required'"
	[errorMessage]="{'required' : 'ctr_1094_HorsDef'}"
	[radios]="[
		{
			label: step2.gettravaux,
			value: travauxValue
		},
		{
			label: step2.getfournitures,
			value: fournituresValue
		},
		{
			label: step2.getservices,
			value: servicesValue
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="description.objet.txtLibre?.champsLibre[0]"
[label]="step2.gettextelibre"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidTxtLibre()+'_SepAtt_champsLibre'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="description.objet.intLibre?.intituleLibre"
[label]="step2.getintitulelibre"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidIntLibre()+'_SepAtt_intituleLibre'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="description.objet.intLibre?.intituleLibreLibelle"
[label]="step2.getintitulelibrelibelle"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidIntLibre()+'_SepAtt_intituleLibreLibelle'">
</app-form-input>

<app-type-travaux *ngIf="false" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [marcheTravaux]="description?.marcheTravaux"></app-type-travaux>

<app-type-fournitures *ngIf="false" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [marcheFournitures]="description?.marcheFournitures"></app-type-fournitures>

<app-form-input *ngIf="false"
[parentForm]="parentForm"
[disabled]="disabled"
[value]="description?.marcheServices"
[label]="step2.getmarcheservices"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_marcheServices'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="description?.isLieuExecutionLivraison"
[label]="step2.getlieuexecutionlivraison"
[checkboxDestination]="'boolean'"
[type]="'checkbox'" [rule]="''"
[name]="getUid()+'_SepAtt_lieuExecutionCB'">
</app-form-input>

<span class="d-block" >{{ step2.getspan1  | translate }}</span>

<app-type-lieu *ngIf="!estCbChecked" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'pattern' : 'ctr_221'}"
[lieuExecutionLivraison]="description?.lieuExecution"></app-type-lieu>
<app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>
<app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg5" [id]="getStepId() + rg5"></app-form-input-error>
<app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg6" [id]="getStepId() + rg6"></app-form-input-error>

<span class="d-block" *ngIf="!estCbChecked">{{ step2.getspan2  | translate }}</span>


<app-type-lieu *ngIf="!estCbChecked"  [uid]="'lieuLivraison'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'pattern' : 'ctr_222'}"
 [lieuExecutionLivraison]="description?.lieuLivraison"></app-type-lieu>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg7" [id]="getStepId() + rg7"></app-form-input-error>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg8" [id]="getStepId() + rg8"></app-form-input-error>
 

<app-type-lieu *ngIf="estCbChecked" [uid]="'lieuExecutionLivraison'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'pattern' : 'ctr_43'}"
 [lieuExecutionLivraison]="description?.lieuExecutionLivraison"></app-type-lieu>
 <app-form-input-error *ngIf="estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>


<app-type-objCPV  [uid]="getUid()" [parentForm]="parentForm" [cpv]="description.descriptionMarche?.cpv"></app-type-objCPV>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg9" [id]="getStepId() + rg9"></app-form-input-error>


<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="description.objet.txtLibre?.champsLibre[1]"
[label]="step2.gettextelibre"
[rule]="'minSize_5|maxSize_250'"
[type]="'text'"
[name]="getUid()+'_SepAtt_champsLibre'">
</app-form-input>




